<template>
  <div class="wrapper">
    <!-- LIST VIEW -->

    <v-list-item three-line v-if="!gridView" dense :class="mediaTypeColor">
      <v-list-item-icon>
        <v-icon medium>mdi-image-multiple</v-icon>
      </v-list-item-icon>
      <v-list-item-content>
        <v-list-item-title class="subtitle-1">
          <span v-html="descriptionText"></span>&nbsp;({{
            galleryContentsCount
          }}
          items)
        </v-list-item-title>
        <v-list-item-subtitle
          >{{ mediaTypeDescription }}
          <span
            v-if="
              media.mediaTypeId !== mediaTypesEnum.poi_image ||
                media.mediaTypeId !== mediaTypesEnum.poi_image_dzi
            "
            >{{ mediaDetailsDescription }}</span
          ></v-list-item-subtitle
        >
        <v-list-item-subtitle>{{ media.url }}</v-list-item-subtitle>
        <v-list-item-subtitle>{{ media.mediaData.path }}</v-list-item-subtitle>
      </v-list-item-content>

      <v-list-item-action>
        <div class="text-xs-right">
          <v-btn icon v-on:click="onClick()" title="Open">
            <v-icon>mdi-folder-open</v-icon>
          </v-btn>
          <v-btn
            icon
            v-on:click="removeMediaItem()"
            color="error"
            title="Delete"
          >
            <v-icon>mdi-close-circle</v-icon>
          </v-btn>
          <v-btn icon v-on:click="edit()" title="Edit">
            <v-icon>edit</v-icon>
          </v-btn>
        </div>
      </v-list-item-action>
    </v-list-item>
    <v-divider v-if="!gridView">&nbsp;</v-divider>

    <!-- GRID VIEW -->
    <v-card
      class="mx-auto"
      :color="mediaTypeColor"
      max-width="400"
      v-if="gridView"
    >
      <v-list-item>
        <v-list-item-avatar color="grey">
          <v-icon medium>mdi-image-multiple</v-icon>
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title class="subtitle-1">
            {{ mediaTypeDescription }}
          </v-list-item-title>
          <v-list-item-subtitle>
            {{ mediaDetailsDescription }}
          </v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>

      <v-card-text>
        <span v-html="descriptionText"></span>
        &nbsp;({{ galleryContentsCount }} items)
      </v-card-text>

      <v-card-actions>
        <v-btn icon v-on:click="onClick()" title="Open">
          <v-icon>mdi-folder-open</v-icon>
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn icon v-on:click="removeMediaItem()" color="error" title="Delete">
          <v-icon>mdi-close-circle</v-icon>
        </v-btn>
        <v-btn icon v-on:click="edit()" title="Edit">
          <v-icon>edit</v-icon>
        </v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import Enums from '../../helpers/Enums'
export default {
  components: {},
  props: {
    media: {
      type: Object,
      required: true,
      default: function() {
        return {}
      }
    },
    gridView: {
      type: Boolean,
      required: false,
      default: function() {
        return false
      }
    }
  },

  created: function() {
    this.getMediaContent(this.$props.media)
  },
  computed: {
    showAddToGalleryDialog: {
      get: function() {
        return this.showDialog
      },
      set: function(newValue) {
        this.showDialog = newValue
      }
    }
  },
  watch: {
    // whenever question changes, this function will run
    galleryContents: function(newContents, oldContents) {
      this.galleryContentsCount = newContents.length
    }
  },
  methods: {
    async edit() {
      var self = this
      await this.$store.dispatch(
        'MediaStore/setSelectedMediaItem',
        this.media.id
      )
      self.$emit('edit')
    },
    getMediaContent: async function(media) {
      this.name = media.name

      this.mediaTypesEnum = Enums.MediaType

      this.mediaTypeDescription = 'Media Gallery'
      this.mediaDetailsDescription = Enums.lang[media.langId].name
      this.descriptionText = media.name
      this.galleryContents = await this.$store.dispatch(
        'MediaStore/getGalleryContents',
        this.media.id
      )
    },
    removeMediaItem: function() {
      this.$store.dispatch('MediaStore/deleteMedia', this.media.id)
      this.$emit('deleted')
    },
    async onClick() {
      await this.$store.dispatch('MediaStore/setSelectedGallery', this.media.id)
      //console.log("CLICKED")
      //this.$router.push('/gallery')
    }
  },
  data: function() {
    return {
      name: '',
      bannerImageUrl: './assets/default_file_icon.png',
      descriptionText: '',
      mediaTypeDescription: '',
      mediaDetailsDescription: '',
      mediaFileDescription: '',
      showDialog: false,
      mediaTypeColor: 'pink darken-1',
      galleryContents: [],
      galleryContentsCount: 0
    }
  }
}
</script>

<style scoped>
.wrapper {
  border-radius: 6px;
  overflow: hidden;
}
.text-xs-right {
  white-space: nowrap;
}
</style>
